import { styled } from '../../../../../styled/styled-components'

export const Main = styled.main`
  margin: 2rem 0;
  padding: 0 2.5rem;
`
export const StyledFlex = styled.div`
  display: flex;
`
export const StyledTabs = styled.div`
  font-size: 18px;
  line-height: 40px;
  color: #aab0bd;
  div[role='tab'] {
    padding: 4px 0;
    margin-right: 7%;
    font-weight: 400;
    padding-bottom: 15px;
  }
  div:hover {
    color: #000000;
  }
  div[aria-selected='true'] {
    color: #000000;
  }
  span {
    left: 0;
    right: 0;
  }
  > div > div > span {
    background: #c4c4c4;
    height: 1px;
  }
  > div > div > span::before,
  > div > div > span::after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    background-color: #c4c4c4;
    height: 1px;
  }
  > div > div > span::before {
    left: -40px;
  }
  > div > div > span::after {
    right: -40px;
  }
  div[aria-selected='true'] span {
    background: #78b833;
    box-shadow: 0px 5px 10px rgba(22, 105, 55, 0.347486);
  }
`
export const StyledHeader = styled.div`
  position: relative;
  margin-bottom: 32px;
  ::before {
    background: #f6f9fc;
    opacity: 0.5;
    content: '';
    display: block;
    position: absolute;
    width: calc(100% + 80px);
    height: calc(100% + 30px);
    z-index: -1;
    top: -30px;
    left: -40px;
  }
  h1 {
    font-size: 34px;
    line-height: 40px;
    color: #171725;
    margin-bottom: 20px;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 400px;
    white-space: nowrap;
  }
`
export const StyledFooter = styled.div`
  background: #f6f9fc;
  height: 80px;
  /* position: absolute; */
  /* width: 100%; */
  /* left: 0; */
  /* bottom: 0; */
  display: flex;
  align-items: center;
  padding: 0 40px 0 50px;
  margin: 0 -40px -30px;
`
export const StyledFooterButton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  button {
    outline: none;
  }
`
export const StyledCancelButton = styled.button`
  background: #f6f9fc;
  border: 1px solid #dee4ec;
  border-radius: 6px;
  height: 40px;
  padding-right: 26px;
  font-size: 16px;
  line-height: 19px;
  color: #aab0bd;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  ::before {
    border: solid #aab0bd;
    border-width: 0 2.4px 2.4px 0;
    display: inline-block;
    padding: 3px;
    content: '';
    transform: rotate(135deg);
    margin: 0 13px 0 16px;
  }
`
export const StyledSubmitButton = styled.button`
  background: #78b833;
  box-shadow: 0px 8px 26px rgba(22, 105, 55, 0.347486);
  border-radius: 6px;
  height: 40px;
  font-size: 16px;
  line-height: 19px;
  color: #fff;
  border: none;
  cursor: pointer;
  font-weight: 500;
  padding: 0 20px;
`
export const StyledField = styled.div`
  margin-bottom: 37px;
`
export const StyledLabel = styled.div`
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 15px;
`
export const StyledInput = styled.input`
  background: #eceff54d;
  border: 1px solid #eceff5;
  box-sizing: border-box;
  border-radius: 6px;
  height: 50px;
  padding: 0 59px 0 19px;
  font-size: 16px;
  line-height: 19px;
  width: 100%;
  outline: none;
`
export const StyledInputSlug = styled.span`
  display: flex;
  align-items: center;
  ::before {
    content: '/';
    position: absolute;
    color: #aab0bd;
    font-size: 16px;
    display: flex;
    align-items: center;
    height: 50px;
    margin-left: 19px;
  }
  ::after {
    content: 'URL-адреса автоматически генерируются для вашей категории, вы можете при желании создать собственный URL-адрес.';
    position: absolute;
    margin-top: 50px;
    color: #000;
    opacity: 0.5;
    font-size: 12px;
  }
  input {
    padding-left: 31px !important;
    color: #000 !important;
  }
`
export const StyledTextArea = styled.textarea`
  background: #eceff54d;
  border: 1px solid #eceff5;
  box-sizing: border-box;
  border-radius: 6px;
  height: 50px;
  padding: 12px 59px 12px 19px;
  font-size: 16px;
  line-height: 19px;
  width: 100%;
  outline: none;
  min-height: 120px;
`
